import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { contactForm } from "./contact-form";
import { recaptchaObject } from "./recaptcha";
import { bookingFormCommon } from "./c005-bookingform-common";
require('parsley');

export class qcvoucherForm {
	private formEl:any = $('#qcvoucherform');
	private $loginError:Array<string> = [];
	$validationSuccess    : any = true;;
	$scope: any = $('#qcvoucherform');
	private contactBase:any = new contactForm();$error:Array<any>;
    private statecodes: any = [];
    private bookingformcommon = new bookingFormCommon();

	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs():any {
		let _self = this;
		let inputElArr:any = _self.formEl.find('input[type="text"], input[type="email"], textarea,input[type="checkbox"],input[type="file"]');

		_self.contactBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
   
    validateForm(): any {
        let _self = this;
        let submitBtn:any = $("#voucher-form-submit");
        let clearBtn:any=$("#clear-form-search");

        submitBtn.click((evt: any) => {
            evt.stopPropagation();
			evt.preventDefault();
            var form_pnr=$('#qcvoucher-form--pnr').val();
            var form_ticketno=$('#qcvoucher-form--ticketno').val();
            let alphaNumericPattern = /^([a-zA-Z0-9_]+)$/;
            let numberPattern = /^\d+$/;           
            $('.error-validation .form-error').addClass('hide');
            $('.error-validation .form-errorvalidationpnr').addClass('hide');
            $('.error-validation .form-errorpnr').addClass('hide');
            $('.error-validation .form-errorvalidation').addClass('hide');
            $('.error-validation .form-message').addClass('hide');
            $('.qcvoucherform .qcvoucher-form--ticketno').removeClass('has-error');
            $('.qcvoucherform .qcvoucher-form--pnr').removeClass('has-error');
            $('.error-validation').hide();
            $('.suceess-validation').addClass('hide'); 

            let $validationSuccess    : any = true;
            // pnr validation
            if(!form_pnr)
                {
                    $('.error-validation').show();
                    $('.error-validation .form-errorpnr').removeClass('hide');
                    $('.qcvoucherform .qcvoucher-form--pnr').addClass('has-error');
                    $validationSuccess = false;
                }
            else{
                if(!(form_pnr.length == 6 && alphaNumericPattern.test(form_pnr)))
                {
                    $('.error-validation .form-errorvalidationpnr').removeClass('hide');
                    $('.error-validation').show(); 
                    $('.qcvoucherform .qcvoucher-form--pnr').addClass('has-error');
                    $validationSuccess = false;
                }
                else
                {
                    $validationSuccess = true;
                }
            }
            // ticket no validation

            if(!form_ticketno){
                $('.error-validation').show();
                $('.error-validation .form-error').removeClass('hide');
                $('.qcvoucherform .qcvoucher-form--ticketno').addClass('has-error');
                $validationSuccess = false;
            }
            else{
                if(!(form_ticketno.length == 13 && numberPattern.test(form_ticketno)))
                {
                    $('.error-validation .form-errorvalidation').removeClass('hide');
                    $('.error-validation').show(); 
                    $('.qcvoucherform .qcvoucher-form--ticketno').addClass('has-error')
                    $validationSuccess = false;
                }
                else
                {
                    $validationSuccess = true;
                }
            }
            if($validationSuccess)
                {

                    let populateurl;
                    if (window.location.hostname === 'localhost' && window.location.port == '5000') {
                        populateurl = '/dummy-data/qcvoucher.json';
                    }
                    else {
                        populateurl = '/bin/services/new/voucherconsent';
                    }
                    let _self = this;
                    let bcommon = _self.bookingformcommon;
                    let data:any=
                    {
                         'pnr':form_pnr,
                         'ticketNumber':form_ticketno
                    }
                    bcommon.preloader();
                    $.ajax({
                        type: 'GET',
                        url:populateurl,
                        data:data,
                        success: function(msg:any) {
                            if(typeof msg==='string'){
                            msg = JSON.parse(msg);
                            }else{
                                msg=msg;
                            }
                            //populating the fields
                            if(msg.code =='GS')
                            {
                                $("input.qcvoucher-form--firstname").val(msg.firstName);
                                $("input.qcvoucher-form--lastname").val(msg.lastName);
                                $("input.qcvoucher-form--email").val(msg.email);
                                $("input.qcvoucher-form--currency").val(msg.currency);
                                $("input.qcvoucher-form--amount").val(msg.amount);
                                $("input.qcvoucher-form--cardgroup").val(msg.group);
                                $('.qcvoucherform .qcvoucher-form--pnr').removeClass('has-error');
                                $('.qcvoucherform .qcvoucher-form--ticketno').removeClass('has-error');
                                $(".form-group").removeClass("qcvoucher--form-convert");
                                $("#voucher-form-submit").addClass('hide');
                                $('.error-validation').hide(); 
                                $('#convert-form-now').addClass('disable_convert');
                                _self.disableInput(true);
                            }
                            else if (msg.code=='GE')
                            {                             
                                $('.error-validation .form-message').removeClass('hide');
                                $('.error-validation .form-message').html(msg.message);
                                $('.error-validation').show();
                                _self.disableInput(false);
                            }
                            else if (msg.code=='GV')
                            {                             
                                $('.error-validation .form-message').removeClass('hide');
                                $('.error-validation .form-message').html(msg.message);
                                $("input.qcvoucher-form--firstname").val(msg.firstName);
                                $("input.qcvoucher-form--lastname").val(msg.lastName);
                                $("input.qcvoucher-form--email").val(msg.email);
                                $("input.qcvoucher-form--currency").val(msg.currency);
                                $("input.qcvoucher-form--amount").val(msg.amount);
                                $("input.qcvoucher-form--cardgroup").val(msg.group);
                                $('.qcvoucherform .qcvoucher-form--pnr').removeClass('has-error');
                                $('.qcvoucherform .qcvoucher-form--ticketno').removeClass('has-error');
                                $(".form-group").removeClass("qcvoucher--form-convert");
                                $("#voucher-form-submit").addClass('hide');
                                $("#convert-form-now").hide();
                                $('.error-validation').show(); 
                                $('.qcvoucher-checkbox').hide();
                                _self.disableInput(true);
                            }
                            bcommon.preloaderClose();
                        }, error: function(error:any) {
                            $('.error-validation .form-message').removeClass('hide');
                            $('.error-validation').show(); 
                            bcommon.preloaderClose();
                        }
            
                    });
                }
        });
        clearBtn.click((evt: any) => {
            evt.stopPropagation();
            evt.preventDefault();
            $("label").removeClass("input-filled");
            $("input.qcvoucher-form--pnr").val("");
            $("input.qcvoucher-form--ticketno").val("");
            $("input.qcvoucher-form--firstname").val("");
            $("input.qcvoucher-form--lastname").val("");
            $("input.qcvoucher-form--email").val("");
            $("input.qcvoucher-form--currency").val("");
            $("input.qcvoucher-form--amount").val("");
            $("input.qcvoucher-form--cardgroup").val("");
            $(".qcvoucher--form-clear").addClass("qcvoucher--form-convert");   
            $("#voucher-form-submit").removeClass('hide');  
            $("#qc-terms--conditions").removeAttr("checked");
            $("#convert-form-now").show();
            $('.suceess-validation').addClass('hide'); 
            $('.error-validation').hide(); 
            $('.error-validation .form-message').addClass('hide');
            $('.qcvoucher-checkbox').show();
            _self.disableInput(false);
        });
    }
    disableInput(flag :any) {
        let inputElArr:any = this.formEl.find('#qcvoucher-form--pnr, #qcvoucher-form--ticketno, #qcvoucher-form--firstname, #qcvoucher-form--lastname, #qcvoucher-form--email, #qcvoucher-form--currency, #qcvoucher-form--amount, #qcvoucher-form--cardgroup');
        if(flag) {
            inputElArr.each((i:number, el:any) => {
                $(el).attr({
                    'disabled': 'disabled'
                });
                $(el).prev().css({
					'background-color': '#eee',
					'border-top-left-radius':'10px',
					'border-top-right-radius': '10px'
				});
            });
        } else {
            inputElArr.each((i:number, el:any) => {
                $(el).removeAttr("disabled");
                $(el).prev().css({
                    'background-color': '#fff',
                    'border-top-left-radius':'10px',
                    'border-top-right-radius': '10px'
                });
            });
        }
    }
    convertVoucher():any{
    
        $('#qc-terms--conditions').click(function() {
            if(this.checked) {
                $('#convert-form-now').removeClass('disable_convert');
            }   
            else{
                $('#convert-form-now').addClass('disable_convert');
            }    
        });
        $("#convert-form-now").click((evt: any) => {
        
            $("#convert-form-now").hide();
            // passing values
            let populateurl;
            if (window.location.hostname === 'localhost' && window.location.port == '5000') {
                populateurl = '/dummy-data/qcvoucher.json';
            }
            else {
                populateurl = '/bin/services/new/voucherconsent';
            }
            let _self = this;
            let bcommon = _self.bookingformcommon;
            let firstName=$("input.qcvoucher-form--firstname").val();
            let lastName=$("input.qcvoucher-form--lastname").val();
            let email=$("input.qcvoucher-form--email").val();
            let currency=$("input.qcvoucher-form--currency").val();
            let amount=$("input.qcvoucher-form--amount").val();
            let group=$("input.qcvoucher-form--cardgroup").val();
            var form_pnr=$('#qcvoucher-form--pnr').val();
            var form_ticketno=$('#qcvoucher-form--ticketno').val();
            let data:any=
            {
                 'pnr':form_pnr,
                 'ticketumber':form_ticketno,
                 'firstName':firstName,
                 'lastName':lastName,
                 'email':email,
                 'currency':currency,
                 'amount':amount,
                 'group':group,
            }
            bcommon.preloader();
            $.ajax({
                type: 'POST',
                url:populateurl,
                data:data,
                success: function(msg:any) {
                    if(typeof msg==='string'){
                    msg = JSON.parse(msg);
                    }else{
                        msg=msg;
                    }
                    //populating the fields
                    if(msg.code =='GS')
                    {
                        $('.suceess-validation p').html(msg.message);
                        $('.suceess-validation').removeClass('hide'); 
                    }
                    else if (msg.code=='GE')
                    {                             
                        $('.error-validation .form-message').removeClass('hide');
                        $('.error-validation .form-message').html(msg.message);
                        $('.error-validation').show(); 
                    }
                    bcommon.preloaderClose();
                }, error: function(error:any) {
                    $('.error-validation .form-api').removeClass('hide');
                    $('.error-validation').show(); 
                    bcommon.preloaderClose();
                }
    
            });
        });
    }
}

let scope:Element = document.querySelector('#qcvoucherform');
if (scope){
	try {
	let qcvoucher = new qcvoucherForm();
        qcvoucher.initTextInputs();
        qcvoucher.validateForm();
        qcvoucher.convertVoucher();
		
	} catch(e) {console.error(e);}
}